module.exports = __webpack_public_path__ + "img/liulang.edc152ba.png";